"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 88.69 24",
    width: "88.69",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#93c01f"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m27.46 16.17a3.91 3.91 0 0 0 -3.85 3.34h-7.95v-18.01a.78.78 0 0 0 -.78-.78h-7a.79.79 0 0 0 -.68.4l-3.86 7-3.11 3.01a.75.75 0 0 0 -.23.55v8.61a.78.78 0 0 0 .79.78h3.36a3.9 3.9 0 0 0 7.55 0h12a3.91 3.91 0 1 0 3.77-4.9zm0 6.27a2.35 2.35 0 1 1 2.35-2.35 2.35 2.35 0 0 1 -2.35 2.35zm-25.89-4.5h3.09a3.88 3.88 0 0 0 -.59 1.57h-2.5zm12.52-1.56h-4.94a4.16 4.16 0 0 0 -1.22-.21 4.07 4.07 0 0 0 -1.26.22h-5.1v-4.39l2.9-2.9a.59.59 0 0 0 .13-.17l3.69-6.64h5.8zm-8.51 3.7a2.35 2.35 0 1 1 2.35 2.35 2.35 2.35 0 0 1 -2.35-2.35zm5.61-2.14h2.9v1.57h-2.31a3.74 3.74 0 0 0 -.59-1.57z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m6.7 10a.72.72 0 0 0 .35.08.78.78 0 0 0 .7-.43l2.13-4.23h1.86a.79.79 0 1 0 0-1.57h-2.34a.78.78 0 0 0 -.7.43l-2.35 4.72a.78.78 0 0 0 .35 1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m87.91 0h-67.32a.78.78 0 0 0 -.78.78v14a.79.79 0 0 0 .78.79h13.41v3.35a.78.78 0 0 0 .79.78h19.46a.79.79 0 0 0 0-1.57h-6.09v-16.54h34.52v16.56h-.84a.79.79 0 0 0 0 1.57h6.07a.78.78 0 0 0 .78-.78v-18.13a.78.78 0 0 0 -.78-.81zm-61.15 14h-5.39v-12.41h5.39zm1.57-12.41h9.6v16.56h-2.33v-3.35a.78.78 0 0 0 -.78-.78h-6.49zm11.16 16.56v-16.56h7.1v16.56zm47.64-16.56v16.56h-2.89v-16.56z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m68 16.17a3.92 3.92 0 1 0 3.91 3.91 3.92 3.92 0 0 0 -3.91-3.91zm2.34 3.91a2.35 2.35 0 1 1 -2.34-2.34 2.35 2.35 0 0 1 2.33 2.34z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m76.76 16.17a3.92 3.92 0 1 0 3.92 3.91 3.92 3.92 0 0 0 -3.92-3.91zm0 6.26a2.35 2.35 0 1 1 2.35-2.35 2.35 2.35 0 0 1 -2.35 2.35z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m59.21 16.17a3.92 3.92 0 1 0 3.91 3.91 3.92 3.92 0 0 0 -3.91-3.91zm2.35 3.91a2.35 2.35 0 1 1 -2.35-2.34 2.35 2.35 0 0 1 2.35 2.34z"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m63.42 14.29v-10.95l9.13 5.47z",
    fill: "#9ece06"
  }));
};

exports["default"] = _default;